import React, { useEffect, useState } from "react";
import "./sidebar.scss";
import { Outlet, Link } from "react-router-dom";
import {
  UserOutlined,
  HomeOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
} from "@ant-design/icons";
import { Menu, Layout, Avatar, Button, Popover, Grid } from "antd";
import { useAuth } from "../Component/hook/auth";

function Sidebar() {
  const { Header, Sider, Content } = Layout;
  const [collapsed, setCollapsed] = useState(false);
  const { logout } = useAuth();

  useEffect(() => {
    if (window && window?.matchMedia(`(max-width: 767px)`)?.matches) {
      setCollapsed(true);
    }
  }, [])

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  // for extra menu
  const content = (
    <div>
      <Button
        className="admin-topbar-btn"
        onClick={() => logout()}
      >
        <LogoutOutlined />
        LogOut
      </Button>
    </div>
  );

  return (
    <>

      {/* Menu extra start */}

      {/* <Switch
              checked={theme === 'dark'}
              onChange={changeTheme}
              checkedChildren="Dark"
              unCheckedChildren="Light"
            />
            <br />
            <br /> */}
      <Layout>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={240}
          style={{
            position: "fixed",
            height: "100vh",
            zIndex: "999",
            left: "0",
          }}
        >
          <button
            title="Toggle Menu"
            className="sidebarWrapperButton sidebarWrapperButton-in"
            onClick={toggleCollapsed}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className="sidebarLogo">
            {collapsed ? (
              <>
                <img alt="logo" src="/asset/logo.png" className="collapsed-img" />
                <span style={{ marginLeft: "0.6rem" }}>
                  <h4 style={{ color: "#fff" }}>BMB</h4>
                </span>
              </>
            ) : (
              <>
                <img alt="logo" src="/asset/logo.png" className="uncollapsed-img" />
                <span>
                  <h4 style={{ color: "#fff" }}>BMB ADMIN</h4>
                </span>
              </>
            )}
          </div>
          <Menu
            mode="inline"
            theme={"dark"}
            defaultOpenKeys={['menu']}
          // inlineCollapsed={collapsed}
          >
            <Menu.Item key="Dashboard" icon={<HomeOutlined />}>
              <span>Dashboard</span>
              <Link to="/" />
            </Menu.Item>

            {/* </Menu.SubMenu> */}
            <Menu.SubMenu
              title="Menu"
              key="menu"
              icon={<MenuFoldOutlined />}
            >
              <Menu.Item key="Announcements">
                <span>Announcements</span>
                <Link to="/announcements" />
              </Menu.Item>
              <Menu.Item key="Sponsers">
                <span>Sponsers</span>
                <Link to="/sponsers" />
              </Menu.Item>
              <Menu.Item key="Events">
                <span>Events</span>
                <Link to="/events" />
              </Menu.Item>
              <Menu.Item key="Certificates">
                <span>Certificates</span>
                <Link to="/certificates" />
              </Menu.Item>
              <Menu.Item key="SendNotification">
                <span>Send Notification</span>
                <Link to="/sendNotification" />
              </Menu.Item>
              <Menu.Item key="Applicant">
                <span>Applicant</span>
                <Link to="/applicant" />
              </Menu.Item>
              <Menu.Item key="Gallery">
                <span>Gallery</span>
                <Link to="gallery" />
              </Menu.Item>
              <Menu.Item key="Bulletin">
                <span>Bulletin</span>
                <Link to="bulletin" />
              </Menu.Item>
              <Menu.Item key="StartQuiz">
                <span>Start Quiz</span>
                <Link to="/start_quiz" />
              </Menu.Item>
            </Menu.SubMenu>
          </Menu>
        </Sider>
        <Layout>
          <Header
            style={{ position: "fixed", top: "0", zIndex: "1", width: "100%" }}
          >
            <div className="topbar">
              <div className="topbarWrapper">
                <div className="topLeft">
                  <span className="admin-logo">
                    {/* BMB ADMIN */}
                  </span>
                </div>
                <div className="topRight">
                  <div className="topbar-text">
                    <h6>Admin</h6>
                  </div>
                  <div className="topbarIcons">
                    <Popover content={content} trigger="hover">
                      <Avatar
                        className="admin-avatar"
                        title="Admin"
                        icon={<UserOutlined />}
                      />
                    </Popover>
                  </div>
                </div>
              </div>
            </div>
          </Header>

          {collapsed ? (
            <Content style={{ marginLeft: "80px", marginTop: "60px" }}>
              <Outlet />
            </Content>
          ) : (
            <Content style={{ margin: "60px 0 0 240px" }}>
              <Outlet />
            </Content>
          )}
        </Layout>
      </Layout>

      {/* Menu extra end */}
    </>
  );
}

export default Sidebar;